<div class="modal-header" [ngClass]="iconTypeLayoutClass()">
  {{ getTranslate("title")}}
  <button class="close" aria-label="Close" (click)="closeModal()" [ngClass]="iconCustomLayoutClass()">
    <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
  </button>
</div>

<form [formGroup]="authForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">

    <!-- Password & Confirm Password -->
    <div class="form-group row required" [ngClass]="iconTypeLayoutClass()">
      <div class="col-sm-12 col-md-6">
        <label class="form-control-label" for="inputPassword">
          <i class="fas fa-lock mr-2"></i>
          <div class="ci ic-lock mr-2"></div>
          {{ getTranslate("newPassword")}}
        </label>
        <input class="form-control" type="password" id="inputPassword" formControlName="password">
        @if (password.invalid && (password.dirty || password.touched)) {
          <div class="alert alert-danger">
            @if (password.errors.required) {
              <div>{{ getTranslate("newPasswordError")}}</div>
            }
          </div>
        }
      </div>
      <div class="col-sm-12 col-md-6">
        <label class="form-control-label" for="inputConfirmPassword">
          <i class="fas fa-lock mr-2"></i>
          <div class="ci ic-lock mr-2"></div>
          {{ getTranslate("confirmPassword")}}
        </label>
        <input class="form-control" type="password" id="inputConfirmPassword" formControlName="confirmPassword">
        @if (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) {
          <div class="alert alert-danger">
            @if (confirmPassword.errors.required) {
              <div>{{ getTranslate("confirmPasswordError") }}</div>
            }
            @if (confirmPassword.value != '' && confirmPassword.errors.MatchPassword) {
              <div>{{ getTranslate("matchPasswordError") }}</div>
            }
          </div>
        }
      </div>
    </div>
    <!-- ./ Password & Confirm Password -->

  </div>

  <div class="modal-footer">
    <button type="submit"
      [style.border]="'1px solid transparent'"
      [disabled]="authenticating"
      class="btn btn-success small-btn"
      [ngClass]="buttonCustomLayoutCss()">
      {{ getTranslate("save") }}
    </button>
  </div>
</form>
